import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { apiUrls } from "../library/Utils";

export const login = createAsyncThunk(
  "login/login",
  async (obj, { dispatch, getState }) => {
    const reqOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        email: obj.email,
        password: obj.password,
      }),
    };
    return fetch(apiUrls.loginUrl, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const forgotPassword = createAsyncThunk(
  "login/forgotPassword",
  async (obj, { dispatch, getState }) => {
    let reqOptions = {};
    reqOptions.method = obj.method;
    let url = apiUrls.forgotPasswordUrl + "?emailId=" + obj.email;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetUserCountries = createAsyncThunk(
  "login/GetUserCountries",
  async (obj, { dispatch, getState }) => {
    let reqOptions = {};
    reqOptions.method = obj.method;
    let url = apiUrls.countryListUrl + obj.userid;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

const initialState = {
  countries: [],
  globalSelectedCountryID: null,
  globalSelectedCountryName: "",
  isLoggedIn: false,
  isGCountryChangedAnalyze: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setState: {
      prepare(stateName, stateValue) {
        return {
          payload: { stateName, stateValue },
        };
      },
      reducer(state, action) {
        const { stateName, stateValue } = action.payload;
        state[stateName] = stateValue;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetUserCountries.pending, (state, action) => {})
      .addCase(GetUserCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
      })
      .addCase(GetUserCountries.rejected, (state, action) => {
        console.log("Error from GetUserCountries", action.error.message);
      });
  },
});

export const { setCountries, setState } = loginSlice.actions;

export default loginSlice.reducer;
